if (process.env.REACT_APP_TO_BUILD === 'website') {
    require('./index.client');
} else if (process.env.REACT_APP_TO_BUILD === 'website-server') {
    require('./index.server');
} else {
    throw new Error('Unknown app: ' + process.env.REACT_APP_TO_BUILD);
}

export {}; // For --isolatedModules 